import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-add-edit-task',
  templateUrl: './add-edit-task.component.html',
  styleUrls: ['./add-edit-task.component.scss']
})
export class AddEditTaskComponent implements OnInit {
  imagePath = environment.image_url;
  batchIndex: number = 0;
  // selectedImages: File[] = [];
  previousImagePath: string = "";
  isLoading: boolean = false;
  diameter = 30;
  color: string;
  mode = 'indeterminate';
  selectedChamp: any = "";
  champList: any[] = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 2000;
  profile = this.appService.getCurrentAccount();
  workOrderId: any = null;
  selectedIndex: any = null;
  field: any;
  i: number;
  @ViewChild('inputElement', { static: true }) inputElement!: ElementRef;
  selectedImages: any[] = [
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482399340.jpeg",
    //   "orderId": "1111111",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482388933.jpeg",
    //   "orderId": "222222222222",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482396502.jpg",
    //   "orderId": "33333333",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482376735.jpg",
    //   "orderId": "",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482370713.jpg",
    //   "orderId": "",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482384026.png",
    //   "orderId": "",
    //   "carNumber": "",
    //   "ticketNumber": null
    // },
    // {
    //   "bucket": "image-data-hour4u-2",
    //   "region": "ap-south-1",
    //   "key": environment.image_url + "dev/workOrder_img/6628c816b6c51d30d08877c3/1717482379011.jpg",
    //   "orderId": "",
    //   "carNumber": "",
    //   "ticketNumber": null
    // }
  ];
  selectedImagesMain: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddEditTaskComponent>,
    public enterpriseAdminService: EnterpriseAdminService,
    private cdRef: ChangeDetectorRef,
    private appService: AppService,
    private notify: NotificationService,
    public jobService: JobService
  ) { }

  ngOnInit() {
    console.log(this.data)
    if (this.data.selectedTask.label == 'Edit') {
      this.previousImagePath = this.data.selectedTask.imagePath;
    }
    this.fetchChamps();
  }

  setArray() {
    console.log(this.data.selectedTask)
    const generateFields = (orderId, key) => {
      let fields = [];

      // Check if order_image field needs to be added
      if (this.data.selectedTask.workProofs.some(field => field.fieldName === "order_image")) {
        fields.push({
          "fieldLabel": "Order Image",
          "fieldName": "order_image",
          "fieldValue": key,
          "fieldType": "file",
          "displayFieldType": "order_image_file"
        });
      }

      // Check if order_id field needs to be added
      if (this.data.selectedTask.workProofs.some(field => field.fieldName === "order_id")) {
        fields.push({
          "fieldLabel": "Order Id",
          "fieldName": "order_id",
          "fieldValue": orderId,
          "fieldType": "text",
          "displayFieldType": "order_id_text"
        });
      }

      return [fields]; // Return the fields array wrapped in another array
    }

    this.selectedImagesMain = this.selectedImages.flatMap(image => generateFields(image.orderId, image.key));
    console.log(this.selectedImagesMain);


  }

  ngAfterViewInit() {
    this.setupDragAndDrop();
  }

  fetchChamps() {
    this.champList = [];
    if (this.data.selectedTask && this.data.selectedTask.champsList) {
      this.data.selectedTask.champsList.forEach(element => {
        let obj = {
          id: element.tempJobSeeker.id,
          name: element.tempJobSeeker.name,
          mobile: element.tempJobSeeker.mobile,
        }
        this.champList.push(obj);
      });
    }

    this.workOrderId = this.data.selectedTask.employmentId;
    if (this.data && this.data.selectedTask && this.data.selectedTask.jobSeekerId) {
      this.selectedChamp = this.data.selectedTask.jobSeekerId;
    } else {
      if (this.data.selectedJobSeeker && this.data.selectedJobSeeker.jobSeekerId) {
        this.selectedChamp = this.data.selectedJobSeeker.jobSeekerId;
      }
    }
  }

  removeImg(field?: any) {
    console.log(field);
    if (field) {
      field.fieldValue = "";
    } else {
      this.data.selectedTask.imagePath = null;
    }
    this.cdRef.detectChanges();
  }

  submit() {
    this.isLoading = true;
    if (this.data && this.data.selectedTask && this.data.selectedTask.multiTaskUpload) {
      console.log(this.data.selectedTask, this.data.selectedTask, this.selectedImages, this.selectedImagesMain)
      let paramsPayload = [];
      this.selectedImagesMain.forEach(element => {
        let param = {
          imagePath: this.data.selectedTask.imagePath,
          workOrderId: this.workOrderId,
          historyDate: this.data.selectedTask.datee ? this.data.selectedTask.datee : new Date(),
          jobSeekerId: this.selectedChamp,
          proofEnum: "MIDDLE",
          description: "",
          workProofs: element
        }
        console.log(param)
        paramsPayload.push(param);
      });
      console.log(paramsPayload)
      this.enterpriseAdminService.SaveAttendanceImgProofs(paramsPayload).subscribe(async (res) => {
        this.isLoading = false;
        this.notify.showMessage("Tasks details added Successfully!", 2000);
        this.dialogRef.close(true);
      }, (err => {
        this.isLoading = false;
      }))

    } else {
      if (this.data.selectedTask.label != 'Edit') {
        let param = {
          imagePath: this.data.selectedTask.imagePath,
          workOrderId: this.workOrderId,
          historyDate: this.data.selectedTask.datee,
          jobSeekerId: this.selectedChamp,
          proofEnum: "MIDDLE",
          description: "",
          workProofs: this.data.selectedTask.workProofs
        }
        this.enterpriseAdminService.SaveAttendanceImgProof(param).subscribe(async (res) => {
          this.isLoading = false;
          this.notify.showMessage("Tasks details added Successfully!", 2000);
          this.dialogRef.close(true);
        }, (err => {
          this.isLoading = false;
        }))
      } else {
        let param = {
          id: this.data.selectedTask.id,
          previousImagePath: this.previousImagePath,
          newImagePath: this.data.selectedTask.imagePath,
          workOrderId: this.workOrderId,
          historyDate: this.data.selectedTask.datee,
          jobSeekerId: this.selectedChamp,
          proofEnum: 'MIDDLE',
          description: "",
          workProofs: this.data.selectedTask.workProofs
        }
        console.log(param)
        this.enterpriseAdminService.UpdateAttendanceImgProof(param).subscribe(async (res) => {
          this.isLoading = false;
          this.notify.showMessage("Tasks details updated Successfully!", 2000);
          this.dialogRef.close(true);
        }, (err => {
          this.isLoading = false;
        }))
      }
    }
  }

  onFileSelected(event: any, field?: any, index?: number) {
    console.log("$$$$$$$$$$$", event, field)
    this.selectedIndex = index;
    this.isLoading = true;
    const files: FileList = event.target.files;
    console.log(files)
    if (field) {
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file && file.type.startsWith('image/')) {
          this.displayThumbnail(file);
          this.compressAndUpload(file, field);
        }
      }
    } else {
      if (this.data.selectedTask && this.data.selectedTask.multiTaskUpload) {
        this.compressAndUploadMultipleFiles(files);
      } else {
        for (let i = 0; i < files.length; i++) {
          const file = files.item(i);
          if (file && file.type.startsWith('image/')) {
            this.displayThumbnail(file);
            this.compressAndUpload(file, field ? field : null);
          }
        }
      }
    }
    this.batchIndex++;
  }

  displayThumbnail(file: File) {
    const thumbnailContainer = document.querySelector('.image-thumbnails');
    if (thumbnailContainer) {
      const thumbnailDiv = document.createElement('div');
      thumbnailDiv.className = 'image-thumbnail';

      // const uploadingTextDiv = document.createElement('div');
      // uploadingTextDiv.className = 'uploading-text';
      //uploadingTextDiv.textContent = 'Uploading...';

      const image = document.createElement('img');
      image.src = URL.createObjectURL(file);
      image.alt = 'Thumbnail';
      image.style.width = '84px';
      image.style.height = '84px';
      image.style.objectFit = 'cover';
      image.style.borderRadius = '12px';
      // thumbnailDiv.appendChild(uploadingTextDiv);
      thumbnailDiv.appendChild(image);

      thumbnailContainer.appendChild(thumbnailDiv);
    }
  }

  compressAndUpload(file: File, field: any) {
    console.log(field)
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const maxWidth = 1800;
    const maxHeight = 1800;
    const image = new Image();
    // const uploadingTextDiv = this.createUploadingTextElement();

    image.onload = () => {
      let width = image.width;
      let height = image.height;

      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width *= ratio;
        height *= ratio;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(image, 0, 0, width, height);
      // let id = this.selectedChamp ? this.selectedChamp : this.data.selectedTask.employmentId;
      canvas.toBlob(
        (blob) => {
          const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });
          let paramType = "orderId, carNumber or ticketNumber";
          let extractTextFromImage = false;
          if (field) {
            if (field.fieldLabel && field.fieldLabel.toLowerCase().includes('ticket') ||
              field.fieldName && field.fieldName.toLowerCase().includes('ticket')) {
              paramType = "ticketNumber";
            } else if (field.fieldLabel && field.fieldLabel.toLowerCase().includes('car') ||
              field.fieldName && field.fieldName.toLowerCase().includes('car')) {
              paramType = "carNumber";
            } else {
              paramType = "orderId";
            }
          }
          if (field.fieldName && field.fieldName.toLowerCase().includes('order') ||
            field.fieldLabel && field.fieldLabel.toLowerCase().includes('order') ||
            field.fieldName && field.fieldName.toLowerCase().includes('ticket') ||
            field.fieldLabel && field.fieldLabel.toLowerCase().includes('ticket') ||
            field.fieldName && field.fieldName.toLowerCase().includes('car') ||
            field.fieldLabel && field.fieldLabel.toLowerCase().includes('car')) {
            extractTextFromImage = true;
          }

          this.enterpriseAdminService.UploadAttendancePicture(this.selectedChamp + '?extractTextFromImage=' + extractTextFromImage + '&paramType=' + paramType, compressedFile, this.batchIndex).subscribe(
            (response: any) => {
              this.isLoading = false;
              // Check if 'field' object exists and 'displayFieldType' is defined
              if (field && field.displayFieldType) {
                // Access 'displayFieldType' property
                if (field.displayFieldType == "order_image_file") {
                  this.data.selectedTask.workProofs.forEach((element: any) => {
                    if (element.fieldName === 'order_id') {
                      if (element.fieldType == 'text' || element.fieldType == 'tel') {
                        if (response.orderId) {
                          element.fieldValue = response.orderId;
                          if (this.inputElement && this.inputElement.nativeElement) {
                            this.inputElement.nativeElement.focus();
                          }
                        }
                      }
                    }
                  });
                }
              }
              // Update imagePath or other properties if needed
              if (field) {
                field.fieldValue = this.imagePath + response.key;
              } else {
                this.data.selectedTask.imagePath = response.key;
              }
              this.cdRef.detectChanges();
            },
            (error) => {
              this.isLoading = false;
              console.error('Error uploading image to S3:', error);
              // Handle error
              // You can add error handling logic here, such as displaying an error message
            }
          );
        },
        'image/jpeg',
        0.6
      );
    };

    image.src = URL.createObjectURL(file);
  }

  compressAndUploadMultipleFiles(files: FileList) {
    console.log(files)
    // return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const maxWidth = 1800;
    const maxHeight = 1800;
    const image = new Image();
    // const uploadingTextDiv = this.createUploadingTextElement();

    const compressFile = (file: File): Promise<File> => {
      return new Promise((resolve, reject) => {
        const image = new Image();

        image.onload = () => {
          let width = image.width;
          let height = image.height;

          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width *= ratio;
            height *= ratio;
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(image, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });
                resolve(compressedFile);
              } else {
                reject(new Error('Compression failed'));
              }
            },
            'image/jpeg',
            0.6
          );
        };

        image.src = URL.createObjectURL(file);
      });
    };

    const fileArray = Array.from(files);
    const compressionPromises = fileArray.map(file => compressFile(file));

    Promise.all(compressionPromises)
      .then((compressedFiles) => {
        this.isLoading = true;
        console.log("compressedFiles===", compressedFiles)
        // Call the API with all compressed files
        let id = this.selectedChamp ? this.selectedChamp : this.data.selectedTask.employmentId;
        this.enterpriseAdminService.UploadAttendancePictures(id, compressedFiles, this.batchIndex).subscribe(
          (response: any) => {
            console.log(response)
            response.forEach(element => {
              element.key = this.imagePath + element.key;
              this.selectedImages.push(element);
            });
            if (this.data.selectedTask && this.data.selectedTask.multiTaskUpload) {
              this.setArray();
            } else {
              this.selectedImagesMain = this.selectedImages;
            }
            // this.selectedImages = response;
            this.isLoading = false;
            this.cdRef.detectChanges();
            console.log('All files have been uploaded successfully');
          },
          (error) => {
            this.isLoading = false;
            console.error('Error uploading images to S3:', error);
          }
        );
      })
      .catch((error) => {
        this.isLoading = false;
        console.error('Error compressing one or more files:', error);
      });

    // image.src = URL.createObjectURL(file);
  }


  disable() {
    let disabled = false;
    // if (!this.activeJobService.activeJobProofs.proofOfWork.proofOfWorkPicturesRequired) {
    //   this.disabled = false;
    // } else {
    if (this.data && this.data.selectedTask && this.data.selectedTask.workProofs && this.data.selectedTask.workProofs.length != 0) {
      this.data.selectedTask.workProofs.forEach((element: any) => {
        if (element.isMandatory) {
          if (!element.fieldValue) {
            disabled = true
          }
        }
        if (element.fieldType === 'tel' && element.fieldValue) {
          if (!/^\d+$/.test(element.fieldValue)) {
            // fieldValue is not a valid number
            disabled = true;
          } else if (element.fieldValue.length !== 10) {
            // fieldValue is a number but not exactly 10 digits long
            disabled = true;
          }
        }
      });
    }


    if (this.data.selectedTask && this.data.selectedTask.forAll) {
      if (!this.selectedChamp) {
        disabled = true;
      }
    }
    // }

    if (this.data.selectedProject && !this.data.selectedProject.manpowerTrackingRequired) {
      if (!this.selectedChamp) {
        disabled = false;
      }
      disabled = false;
    }

    if (this.isLoading) {
      disabled = true;
    }
    return disabled;
  }

  //start drag drop

  setupDragAndDrop() {
    const dropArea = document.querySelector('.upload-file-section');

    if (dropArea) {
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, this.preventDefaults, false);
      });

      ['dragenter', 'dragover'].forEach(eventName => {
        dropArea.addEventListener(eventName, this.highlight.bind(this), false);
      });

      ['dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, this.unhighlight.bind(this), false);
      });

      dropArea.addEventListener('drop', this.handleDrop.bind(this), false);
    }
  }

  preventDefaults(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  highlight(e: Event) {
    const dropArea = e.target as HTMLElement;
    dropArea.classList.add('highlight');
  }

  unhighlight(e: Event) {
    const dropArea = e.target as HTMLElement;
    dropArea.classList.remove('highlight');
  }

  handleDrop(e: DragEvent, field: any) {
    this.preventDefaults(e);
    this.unhighlight(e);

    const dt = e.dataTransfer;
    const files = dt.files;

    if (files) {
      this.isLoading = true;
      this.handleFiles(files, field);
    }
  }

  handleFiles(files: FileList, field: any) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type.startsWith('image/')) {
        this.displayThumbnail(file);
        this.compressAndUpload(file, field);
      }
    }
  }

  uploadFile(file, field) {
    if (file.type.startsWith('image/')) {
      this.displayThumbnail(file);
      this.compressAndUpload(file, field);
    }
  }


  // end drag drop
}
